module.exports = __webpack_public_path__ + "img/YT.8b803bb8.svg";